import React,{useContext} from "react";
import * as FaIcons from "react-icons/fa";
import IntersessionTable from "./intersessionTable";
import SearchForm from "./SearchForm";
import { Link } from "react-router-dom";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";

const IntersessionList = ({ items }) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const listView = true;
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { searchFilterLelo, clearSearchFilterLelo } = adminRegistrationContext;

  // Handle null items
  const safeItems = items || [];

  return (
    <div className="forms-list">
      <div
        className="add-btn-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      {user &&
        (user.userStatus === "Admin" ||
          user.userStatus === "Super Admin") && (

        <Link to="/addLELO">
          <div className="btn btn-llac-dark-green">
            Add New Registration Profile{" "}
            <FaIcons.FaPlus className="plus-icon" />
          </div>
        </Link>
      )}

      </div>
      <SearchForm
        placeholderText="Search Fields"
        searchFilter={searchFilterLelo}
        clearSearchFilter={clearSearchFilterLelo}
      />
       <p className="num-count">{`${safeItems.length} Sessions`}</p>
      {safeItems.length ? (
        <IntersessionTable items={safeItems} />
      ) : (
        <div className="interest-complete">
          <FaIcons.FaCheckSquare className="done-icon" />
          <p>Looks like we're out of profiles to process</p>
        </div>
      )}
    </div>
  );
};

export default IntersessionList;
